import { SnugAppQueryProvider } from 'components/OnboardingQueryProvider'
import { connect } from 'react-redux'

import { RentalHistoryForm } from 'app/profile/renter/refactor_rental_history/components/RentalHistoryForm/RentalHistoryForm'
import type { RentalHistoryFormValues } from 'app/profile/renter/refactor_rental_history/components/RentalHistoryForm/types'

/**
 * Main Rental History Form Component
 *
 * This is the main export for the refactored rental history form.
 * It provides a clean interface for integrating the form into other parts of the application.
 */
interface RentalHistoryFormProps {
  isEditMode?: boolean
  initialData?: Partial<RentalHistoryFormValues> & { id?: string }
  onSuccess?: (data: any) => void
  onError?: (error: string) => void
  isQLDForm22?: boolean
  className?: string
}

export type { RentalHistoryFormProps }

// Re-export types for convenience
export type {
  RentalHistoryFormValues,
  RentalHistoryFormErrors,
  TenantFormValues,
  AddressFormValues,
  LedgerAttachmentFormValues,
} from 'app/profile/renter/refactor_rental_history/components/RentalHistoryForm/types'

// Re-export API hooks for data management
export {
  useRentalHistoryList,
  useCreateRentalHistory,
  useUpdateRentalHistory,
  useDeleteRentalHistory,
} from 'app/profile/renter/refactor_rental_history/components/RentalHistoryForm/http'

// Map Redux state to component props
const mapStateToProps = (state: any) => {
  // Extract team, user, and agency data from Redux session state
  const currentTeam = state.session?.currentTeam
  const currentUser = state.session?.currentUser
  const currentAgency = state.session?.currentAgency

  return {
    currentTeam,
    currentUser,
    currentAgency,
  }
}

// No actions needed - API mutations handle state updates
const mapDispatchToProps = {}

// Wrapper component that provides both Redux state and QueryClient
const RentalHistoryFormWrapper = (props: any) => (
  <SnugAppQueryProvider>
    <RentalHistoryForm {...props} />
  </SnugAppQueryProvider>
)

// Connect the wrapper component to Redux store
const ConnectedRentalHistoryForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RentalHistoryFormWrapper)

export default ConnectedRentalHistoryForm
